const toFormDataUtils = (data: any) => {
  const formData = new FormData();
  Object.keys(data).forEach((val) => {
    if (data[val] !== null) {
      if (val === "image" && typeof data["image"] === "string") {
        formData.append("image", "");
      } else if (val === "image" && typeof data["image"] !== "string") {
        const file: any = data[val];
        formData.append(val, file, file.name);
      } else if (Array.isArray(data[val])) {
        for (const dataArray of data[val]) {
          formData.append(val, dataArray);
        }
      } else {
        formData.append(val, data[val]);
      }
    } else {
      return null;
    }
  });
  return formData;
};

export const isValidValue = (value: any): boolean => {
  if (!value) return false;

  return Boolean(
    Array.isArray(value)
      ? value?.length && value.every((e) => e)
      : (typeof value === "string" ? value.trim() : value) ||
          (value instanceof File && value.size)
  );
};
export const toFormDataUtilsV2 = (data: Record<string, any>): FormData => {
  const formData = new FormData();

  const handleFileArray = (key: string, value: any[]) => {
    value.forEach((item, index) => {
      if (item instanceof File) {
        formData.append(`${key}`, item, item.name);
      }
    });
  };

  const handleRegularArray = (key: string, value: any[]) => {
    value.forEach((item) => {
      if (item) formData.append(key, item);
    });
  };

  Object.entries(data).forEach(([key, value]) => {
    if (!isValidValue(value)) return;

    if (!Array.isArray(value)) {
      formData.append(key, value);
      return;
    }

    if (value[0] instanceof File) {
      handleFileArray(key, value);
    } else {
      handleRegularArray(key, value);
    }
  });

  return formData;
};

export default toFormDataUtils;
